// extracted by mini-css-extract-plugin
module.exports = {"withoutInputShift":"_20mcd","inputShift":"_2uNqG","focused":"_1EiBa","active":"_3NMN-","phoneNumberPrefix":"_1O1ok","withPrefix":"_3WHsb","error":"_2Icpb","rightImg":"_3wjF9"};